import { XCircleSolidIcon } from '@glu/icons-react';
import { createUseStyles } from '@glu/theming';
import React from 'react';
import { AccessibilityText } from '@glu/utilities-react';
import locale from '@glu/locale';
import styles from './Badge.styles';
import { PanelOption } from './Dropdown';

const useStyles = createUseStyles(styles);

interface Props {
  /** Callback to apply the selection */
  applySelection(selection: PanelOption[]): void;

  /** whether the badge is disabled or not */
  disabled?: boolean;

  /** The index of this badge in the list */
  index: number;

  /** Onclick handler when badge text is clicked on */
  onClick(event?: React.MouseEvent<HTMLSpanElement>): void;

  /** A single option object. */
  option: PanelOption;

  /** Object representing the state of the current selection */
  selection: PanelOption[];
}

const Badge = ({ applySelection, disabled, index, onClick, option, selection }: Props) => {
  const classes = useStyles();

  const handleOnClick = (event) => {
    event.stopPropagation();
    applySelection(selection.filter((curr) => curr.id !== option.id));
  };
  const handleOnKeyDown = (event) => {
    event.stopPropagation();
    if (event.key === 'Enter') {
      applySelection(selection.filter((curr) => curr.id !== option.id));
    }
  };
  return (
    <span key={option.id} className={classes.root} data-qa="input-value">
      <span
        onClick={onClick}
        onKeyDown={(event) => {
          event.stopPropagation();
          if (event.key === 'Enter') {
            onClick();
          }
        }}
        role="button"
        tabIndex={0}
      >
        {option.name}
      </span>
      <span
        className={classes.badge}
        disabled={disabled}
        onClick={handleOnClick}
        onKeyDown={handleOnKeyDown}
        role="button"
        tabIndex={0}
        title={locale.get('clear')}
      >
        <AccessibilityText>Clear Selection</AccessibilityText>
        <XCircleSolidIcon className={classes.clear} />
        {index + 1 < selection.length && locale.get('badgeSeperator')}
      </span>
    </span>
  );
};

export default Badge;
